import * as React from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface ScheduleWarning {
  message: string;
  hintedTime?: string;
}

interface ScheduleWarningBannerProps {
  warning: ScheduleWarning | string | null;
}

function formatHintedTime(hintedTime: string): string {
  const date = new Date(hintedTime);
  if (isNaN(date.getTime())) return hintedTime;
  return date.toLocaleString([], {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function ScheduleWarningBanner({ warning }: ScheduleWarningBannerProps) {
  if (!warning) return null;

  const message = typeof warning === 'string' ? warning : warning.message;
  const hintedTime = typeof warning === 'string' ? null : (warning.hintedTime ?? null);

  return (
    <Alert
      role="alert"
      aria-label="Session time doesn't match your offering schedule"
      data-testid="schedule-warning"
      className="border-amber-200 bg-amber-50 text-amber-900"
    >
      <AlertTitle>Session time doesn't match your offering schedule</AlertTitle>
      <AlertDescription className="space-y-1">
        <p>{message}</p>
        {hintedTime !== null && (
          <p className="text-xs text-amber-700">Suggested time: {formatHintedTime(hintedTime)}</p>
        )}
      </AlertDescription>
    </Alert>
  );
}
